import food1 from "../../assests/food-1.png"
import food2 from "../../assests/food-2.png"
import food3 from "../../assests/food-3.png"
import food4 from "../../assests/food-4.png"

export const food = [
    {
        id:1,
        image: food1,
        title:"Burgers",
    },
    {
        id:2,
        image: food2,
        title:"Pizza",
    },
    {
        id:3,
        image: food3,
        title:"Greens",
    },
    {
        id:4,
        image: food4,
        title:"Chicken",
    },
]